import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "dialog-footer"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "专属广告经理会在1~2个工作日内联系您", -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_t_form = _resolveComponent("t-form");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_client_only = _resolveComponent("client-only");
  return _openBlock(), _createBlock(_component_client_only, null, {
    default: _withCtx(() => [_createVNode(_component_el_dialog, {
      modelValue: _ctx.isDialogVisibled,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.isDialogVisibled = $event),
      "modal-class": "customized-form-dialog",
      title: "请填写信息，便于我们联系您！",
      width: _ctx.dialogWidth,
      onClosed: _ctx.closeDialog
    }, {
      default: _withCtx(() => [_createVNode(_component_t_form, {
        ref: "formRef",
        model: _ctx.formData,
        "item-config": _ctx.formConfig,
        gutter: 0,
        "label-position": "right",
        "label-width": "96px",
        size: "large"
      }, null, 8, ["model", "item-config"]), _createElementVNode("div", _hoisted_1, [_createVNode(_component_el_button, {
        class: "submit-btn",
        size: "large",
        type: "primary",
        onClick: _ctx.handleSubmit
      }, {
        default: _withCtx(() => [_createTextVNode(" 提交 ")]),
        _: 1
      }, 8, ["onClick"]), _hoisted_2])]),
      _: 1
    }, 8, ["modelValue", "width", "onClosed"])]),
    _: 1
  });
}